/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmCommandFilter extends models.AwsSsmExecutionFilter {
    constructor() {
        super();
        this.setDiscriminator("AwsSsmCommandFilter");
    }

    getFixupPrototypeFunction() { return AwsSsmCommandFilter.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmCommandFilter>): AwsSsmCommandFilter {
        let obj = Object.assign(new AwsSsmCommandFilter(), model);
        AwsSsmCommandFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmCommandFilter>): AwsSsmCommandFilter {
        if (!model) return null;
        return AwsSsmCommandFilter.newInstance(<AwsSsmCommandFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmCommandFilter) {
        if (!obj) return;

        models.AwsSsmCommandFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmCommandFilter): boolean {
        if (models.AwsSsmExecutionFilter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSsmCommandFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Status of the Execution
     */
    status: models.AwsSsmCommandExecutionStatus;

}
